import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

export default class extends Controller {
  connect() {
    const bibGroupSelect = document.getElementById("bib_group_select");
    const bibNumberSelect = document.getElementById("bib_number_select");

    if (!bibGroupSelect || !bibNumberSelect) return;

    const bibData = document.getElementById("bib-data").dataset;
    const bibGroupNumbers = JSON.parse(bibData.bibGroupNumbers);
    const originalGroupId = bibData.selectedBibGroup ? parseInt(bibData.selectedBibGroup, 10) : null;
    const originalBibNumber = bibData.selectedBibNumber ? parseInt(bibData.selectedBibNumber, 10) : null;

    let tomSelectInstance = null;

    const updateBibNumberOptions = (groupId, preselectNumber = null) => {
      const match = bibGroupNumbers.find(entry => entry[0] === groupId);
      const numbers = match ? match[2] : [];

      if (tomSelectInstance) {
        tomSelectInstance.destroy();
      }

      bibNumberSelect.innerHTML = "";

      if (numbers.length === 0) {
        bibNumberSelect.innerHTML = `<option disabled>No numbers available</option>`;
        return;
      }

      numbers.forEach(number => {
        const option = document.createElement("option");
        option.value = number;
        option.textContent = number;

        if (number === preselectNumber) {
          option.selected = true;
        }

        bibNumberSelect.appendChild(option);
      });

      tomSelectInstance = new TomSelect(bibNumberSelect, {
        create: false,
        sortField: { field: "text", direction: "asc" },
        placeholder: "Search or select a bib number",
      });
    };

    if (originalGroupId) {
      bibGroupSelect.value = originalGroupId;
      updateBibNumberOptions(originalGroupId, originalBibNumber);
    } else {
      bibGroupSelect.value = "not_racing";
      if (tomSelectInstance) {
        tomSelectInstance.destroy();
      }
      bibNumberSelect.innerHTML = `<option disabled>Select a bib group</option>`;
    }

    bibGroupSelect.addEventListener("change", function () {
      const selectedId = parseInt(this.value, 10);
      if (!isNaN(selectedId)) {
        const preselectNumber = selectedId === originalGroupId ? originalBibNumber : null;
        updateBibNumberOptions(selectedId, preselectNumber);
      } else {
        if (tomSelectInstance) {
          tomSelectInstance.destroy();
        }
        bibNumberSelect.innerHTML = `<option disabled>Select a bib group</option>`;
      }
    });
  }
}
